import { foldText } from '../text/normalize.js';
const ALLERGEN_KEYWORDS = {
    gluten: [
        'flour',
        'mehl',
        'wheat',
        'weizen',
        'bread',
        'brot',
        'pasta',
        'nudel',
        'spaghetti',
        'penne',
        'seitan',
        'barley',
        'gerste',
        'rye',
        'roggen',
        'spelt',
        'dinkel',
        'couscous',
        'bulgur',
        'semolina',
        'griess',
        'breadcrumb',
        'paniermehl',
        'semmelbrosel',
        'soy sauce',
        'sojasauce',
        'sojasosse',
        'beer',
        'bier',
        'malt',
        'malz',
        'oat',
        'hafer',
        'tortilla',
        'pizza',
        'croissant',
        'puff pastry',
        'blatterteig',
        'filo',
        'yufka',
    ],
    crustaceans: [
        'shrimp',
        'prawn',
        'garnele',
        'crab',
        'krabbe',
        'krebs',
        'lobster',
        'hummer',
        'crayfish',
        'langoustine',
        'scampi',
    ],
    eggs: [
        'egg',
        'eier',
        'mayonnaise',
        'mayo',
        'aioli',
        'meringue',
        'baiser',
        'hollandaise',
        'custard',
    ],
    fish: [
        'fish',
        'fisch',
        'salmon',
        'lachs',
        'tuna',
        'thunfisch',
        'cod',
        'kabeljau',
        'anchov',
        'sardelle',
        'sardine',
        'trout',
        'forelle',
        'mackerel',
        'makrele',
        'herring',
        'hering',
        'fish sauce',
        'fischsauce',
        'worcestershire',
        'halibut',
        'heilbutt',
        'seabass',
        'wolfsbarsch',
        'dorade',
        'zander',
        'pollock',
        'seelachs',
    ],
    peanuts: ['peanut', 'erdnuss', 'erdnuss', 'satay'],
    soy: ['soy', 'soja', 'tofu', 'tempeh', 'edamame', 'miso', 'tamari'],
    milk: [
        'milk',
        'milch',
        'butter',
        'cheese',
        'kase',
        'cream',
        'sahne',
        'rahm',
        'yogurt',
        'yoghurt',
        'joghurt',
        'quark',
        'kefir',
        'mascarpone',
        'ricotta',
        'mozzarella',
        'parmesan',
        'feta',
        'ghee',
        'whey',
        'molke',
        'creme fraiche',
        'buttermilk',
        'buttermilch',
        'schmand',
        'gouda',
        'cheddar',
        'brie',
        'camembert',
        'halloumi',
        'paneer',
        'ice cream',
        'speiseeis',
    ],
    tree_nuts: [
        'almond',
        'mandel',
        'walnut',
        'walnuss',
        'hazelnut',
        'haselnuss',
        'cashew',
        'pistachio',
        'pistazie',
        'pecan',
        'macadamia',
        'brazil nut',
        'paranuss',
        'chestnut',
        'marzipan',
        'nougat',
        'praline',
        'nut',
        'nuss',
        'nusse',
    ],
    celery: ['celery', 'sellerie', 'celeriac'],
    mustard: ['mustard', 'senf'],
    sesame: ['sesame', 'sesam', 'tahini', 'tahin'],
    sulphites: [
        'wine',
        'wein',
        'dried apricot',
        'getrocknete aprikose',
        'raisin',
        'rosine',
        'vinegar',
        'essig',
        'sulfite',
        'sulphite',
    ],
    lupin: ['lupin', 'lupine'],
    molluscs: [
        'mussel',
        'muschel',
        'squid',
        'calamari',
        'tintenfisch',
        'octopus',
        'oktopus',
        'clam',
        'venusmuschel',
        'oyster',
        'auster',
        'scallop',
        'jakobsmuschel',
        'snail',
        'schnecke',
    ],
};
const MEAT_KEYWORDS = [
    'chicken',
    'hahnchen',
    'huhn',
    'hendl',
    'beef',
    'rind',
    'pork',
    'schwein',
    'lamb',
    'lamm',
    'bacon',
    'speck',
    'ham',
    'schinken',
    'sausage',
    'wurst',
    'turkey',
    'pute',
    'truthahn',
    'veal',
    'kalb',
    'steak',
    'mince',
    'hackfleisch',
    'hack',
    'salami',
    'prosciutto',
    'chorizo',
    'duck',
    'ente',
    'goose',
    'gans',
    'venison',
    'wild',
    'rabbit',
    'kaninchen',
    'gelatin',
    'gelatine',
    'lard',
    'schmalz',
    'meat',
    'fleisch',
    'bratwurst',
    'kebab',
    'doner',
    'pepperoni',
];
const FISH_SEAFOOD = [
    ...ALLERGEN_KEYWORDS.fish,
    ...ALLERGEN_KEYWORDS.crustaceans,
    ...ALLERGEN_KEYWORDS.molluscs,
];
const ANIMAL_PRODUCTS = [...ALLERGEN_KEYWORDS.milk, ...ALLERGEN_KEYWORDS.eggs, 'honey', 'honig'];
const EXCEPTIONS = [
    [
        'milk',
        [
            'coconut milk',
            'kokosmilch',
            'oat milk',
            'hafermilch',
            'almond milk',
            'mandelmilch',
            'soy milk',
            'sojamilch',
            'plant milk',
            'pflanzenmilch',
            'rice milk',
            'reismilch',
            'milk-free',
            'vegan',
        ],
    ],
    [
        'butter',
        [
            'peanut butter',
            'erdnussbutter',
            'almond butter',
            'mandelbutter',
            'cocoa butter',
            'kakaobutter',
            'vegan butter',
            'butternut',
        ],
    ],
    ['cream', ['coconut cream', 'kokoscreme', 'cream of tartar', 'ice cream', 'creamed']],
    [
        'nut',
        [
            'nutmeg',
            'muskatnuss',
            'coconut',
            'kokosnuss',
            'butternut',
            'donut',
            'doughnut',
            'chestnut',
            'water chestnut',
        ],
    ],
    [
        'wild',
        [
            'wild rice',
            'wildreis',
            'wild garlic',
            'barlauch',
            'wild mushroom',
            'wildkrauter',
            'wild herb',
        ],
    ],
    ['hack', ['veggie hack', 'veganes hack', 'soja hack', 'sojahack']],
    ['egg', ['eggplant', 'vegan egg', 'egg-free', 'egg replacer']],
    ['wein', ['weintraube', 'weinessig', 'weinblatt', 'weinblatter']],
    ['wine', ['wine vinegar']],
    ['fish', ['fish-free', 'vegan fish']],
    ['ei', ['eis', 'einlegen', 'reis', 'eier-ersatz']],
];
function containsKeyword(name, keyword) {
    if (!name.includes(keyword))
        return false;
    const exceptions = EXCEPTIONS.find(([k]) => k === keyword)?.[1] ?? [];
    if (exceptions.some((ex) => name.includes(ex)))
        return false;
    // Short keywords must match a whole word to avoid "ei" in "reis".
    if (keyword.length <= 3)
        return new RegExp(`(^|[^a-z])${keyword}(e|er|s|n)?([^a-z]|$)`).test(name);
    return true;
}
/** Allergens suggested for a single ingredient name. */
export function detectAllergens(ingredientName) {
    const name = foldText(ingredientName);
    const hits = [];
    for (const [allergen, keywords] of Object.entries(ALLERGEN_KEYWORDS)) {
        if (keywords.some((kw) => containsKeyword(name, kw)))
            hits.push(allergen);
    }
    return hits;
}
export function detectAllergensForRecipe(ingredientNames) {
    const set = new Set();
    for (const n of ingredientNames)
        for (const a of detectAllergens(n))
            set.add(a);
    return [...set];
}
/**
 * Suggest dietary labels from ingredient names. This is a heuristic and the UI must
 * show it as "AI suggested – verify" until a user confirms.
 */
export function inferDietaryLabels(ingredientNames) {
    const folded = ingredientNames.map((n) => ({ raw: n, f: foldText(n) }));
    const find = (keywords) => folded.filter(({ f }) => keywords.some((kw) => containsKeyword(f, kw))).map((x) => x.raw);
    const meat = find(MEAT_KEYWORDS);
    const seafood = find(FISH_SEAFOOD);
    const animal = find(ANIMAL_PRODUCTS);
    const gluten = find(ALLERGEN_KEYWORDS.gluten);
    const dairy = find(ALLERGEN_KEYWORDS.milk);
    const nuts = find([...ALLERGEN_KEYWORDS.tree_nuts, ...ALLERGEN_KEYWORDS.peanuts]);
    const eggs = find(ALLERGEN_KEYWORDS.eggs);
    const soy = find(ALLERGEN_KEYWORDS.soy);
    const suggested = [];
    const blockers = {};
    const consider = (label, blocking) => {
        if (blocking.length === 0)
            suggested.push(label);
        else
            blockers[label] = [...new Set(blocking)];
    };
    consider('vegetarian', [...meat, ...seafood]);
    consider('vegan', [...meat, ...seafood, ...animal]);
    consider('pescatarian', meat);
    consider('gluten_free', gluten);
    consider('dairy_free', dairy);
    consider('nut_free', nuts);
    consider('egg_free', eggs);
    consider('soy_free', soy);
    return { suggested, blockers };
}
/** Compare a recipe against user preferences and avoided ingredients. */
export function findPreferenceConflicts(ingredientNames, preferences) {
    const conflicts = [];
    const inference = inferDietaryLabels(ingredientNames);
    for (const pref of preferences.dietaryPreferences) {
        const blocked = inference.blockers[pref];
        if (blocked && blocked.length)
            conflicts.push({ kind: 'DIETARY', label: pref, ingredients: blocked });
    }
    for (const avoided of preferences.avoidedIngredients) {
        const key = foldText(avoided);
        if (!key)
            continue;
        const hits = ingredientNames.filter((n) => foldText(n).includes(key));
        if (hits.length)
            conflicts.push({ kind: 'AVOIDED_INGREDIENT', label: avoided, ingredients: hits });
    }
    return conflicts;
}
//# sourceMappingURL=labels.js.map